import {debounce} from "../../utils"
import MartialTree from "./martialTree.vue"

function setTreeData(arr) {
    arr.forEach(function (item) {
        delete item.children;
    });
    let map = {};
    arr.forEach(i => {
        map[i.id] = i;
    });
    let treeData = [];
    arr.forEach(child => {
        const mapItem = map[child.pId];
        if (mapItem) {
            (mapItem.children || (mapItem.children = [])).push(child);
        } else {
            treeData.push(child);
        }
    });
    return treeData;
}

function getParentIdList(arrList, keyId, keyName) {
    if (!arrList || !keyId) return
    let newArr = []
    let findParent = function (dataList, nodeId, parentId) {
        for (var i = 0, length = dataList.length; i < length; i++) {
            let node = dataList[i];
            if (node[keyName] === nodeId) {
                newArr.unshift(nodeId);
                if (nodeId === arrList[0][keyName]) break
                findParent(arrList, parentId)
            } else if (node.children) {
                findParent(node.children, keyId, node[keyName]);
            }
        }
        return newArr;
    }
    return findParent(arrList, keyId);
}

export default {
    components: {MartialTree},
    data() {
        return {
            siteCode: this.$route.params.siteCode,
            siteId: "",
            // img:require("@/assets/images/backgroundimg.png"),
            areaCode: "",
            cityList: [],
            infoPriceReleaseType: "",
            areaValue: '',
            activeIndex: 0,
            yearValue: null,
            yearFValue: null,
            yearList: [],
            numberValue: null,
            numberFValue: null,
            numberList: [],
            numberFList: [],
            cityOptions: [],
            aeraValueList: [],
            aeraValueListTotal: [],
            materialParam: '',//编码
            detailWidth: 300,
            //
            initSearchIdList: '',
            gData: [],
            spinning: false,
            treeId: '',
            // 表格
            seachForm: {},
            tableData: [],
            loading: false,
            page: {
                pageNum: 1,
                total: 0,
                pageSize: 10,
            },
            //信息说明
            detailInfo: [],
            defaultActiveKeyCity: '',
            detailDataList: [],
            defaultActiveKeyData: '',
            detailContain: '',
            previousError: '',
            oldInfoUrl: "",
            sectionExplains: "",
            activeKey: ['1'],
        }
    },
    async created() {
        await this.getSiteInfo()
        await this.getCity()
        if (this.siteCode === 'gss') {
            await this.getGSCity()
        }
        this.sectionExplains = ""
        await this.getYears()
        await this.getNumber()
        await this.getInfo()
        await this.searchTableData()
        await this.getInfo()
        // await this.createTimer();
        if (this.siteCode === 'gss') {
            await this.getGSMaterial()
        } else {
            await this.getMaterial()
        }
    },
    mounted() {
        this.dragControllerDiv();
        this.creatResize()
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.__resizeHanlder)
    },
    methods: {

        getOldData() {
            this.getOldUrlToken();
        },
        /*createTimer() {
            setInterval(() => {
                this.getOldUrlToken();
            }, 90000);
        },*/

        getOldUrlToken: function () {
            let url = "http://cbsynthesis.gldjc.com/toInfoSearch/historyPrice"
            window.open(url)
            /*this.$axios.get("/sdlczj/Ashx/gettoken.ashx").then(res => {
                let url = "http://www.lcgczj.cn/sdlczj/xzspjggs/XZSPJGGS_MoreInfo4znew.aspx?token=" + res.data.data.Token
                window.open(url)
            }).catch(err => {
                console.log(err || "网络错误，请检查网络连接")
            })*/
        },

        dragControllerDiv: function () {
            // 保留this引用
            let data = this;
            let resize = document.getElementById("resize");
            resize.onmousedown = function (e) {
                // 颜色改变提醒
                resize.style.color = "#1B8ADB";
                let startX = e.clientX;
                resize.left = resize.offsetLeft;
                document.onmousemove = function (e) {
                    // 计算并应用位移量
                    let endX = e.clientX;
                    let moveLen = startX - endX;
                    startX = endX;
                    data.detailWidth -= moveLen;
                };
                document.onmouseup = function () {
                    // 颜色恢复
                    resize.style.color = "";
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
                return false;
            };
        },
        creatResize() {
            this.__resizeHanlder = debounce(() => {
                var iframe = window.parent.document.getElementById('menuFrame');
                if (iframe) {
                    this.$nextTick(() => {
                        var height = this.$refs.toInSearchBody.offsetHeight
                        iframe.height = height + 20
                    })
                }
            }, 50)
            window.addEventListener('resize', this.__resizeHanlder)
        },
        //获取城市站点
        async getSiteInfo() {
            await this.$axios.get("/new/search/getSiteInfo", {params: {siteCode: this.siteCode}}).then(res => {
                if (res.data.success) {
                    this.siteId = res.data.obj.siteId
                    this.infoPriceReleaseType = res.data.obj.infoPriceReleaseType
                    this.areaCode = res.data.obj.areaCode
                }
            }).catch(err => {
                console.log(err || "网络错误，请检查网络连接")
            })
        },
        // 获取城市信息
        async getCity() {
            await this.$axios.get("/new/search/getAreaInfoList", {params: {siteId: this.siteId}}).then(res => {
                if (res.data.success && res.data.obj) {
                    if (this.siteCode === 'gss') {
                        let newArr = res.data.obj
                        this.aeraValueList.push(newArr[0].areaCode)
                    } else {
                        this.cityList = res.data.obj
                        this.areaValue = this.cityList[0].areaCode
                    }
                }
            }).catch(err => {
                console.log(err || "网络错误，请检查网络连接")
            })
        },
        async getGSCity() {
            await this.$axios.post("/old/areaTree/ajax/areaAllTree?areaCode=" + this.areaCode,).then(res => {
                if (res.data) {
                    if (this.siteCode === 'gss') {
                        this.cityOptions = setTreeData(res.data)
                        let selectAll = getParentIdList(this.cityOptions, Number(this.aeraValueList[0]), 'id')
                        this.aeraValueListTotal.push(selectAll)
                    }
                }
            }).catch(err => {
                console.log(err || "网络错误，请检查网络连接")
            })
        },
        // 获取日期信息
        async getYears() {
            let areaCodeList = []
            if (this.siteCode === 'gss') {
                areaCodeList = this.aeraValueList
            } else {
                areaCodeList = [this.areaValue]
            }
            let data = {
                areaCodeList,
                siteId: this.siteId,
                materialParam: this.materialParam,
            }
            await this.$axios.post("/new/search/infoDateList", data).then(res => {
                if (res.data.success && res.data.obj) {
                    this.yearList = res.data.obj.infoYearList
                    this.yearValue = this.yearList[this.yearList.length - 1]
                    if (this.siteCode === 'gss') {
                        this.yearFValue = this.yearList[this.yearList.length - 1]
                    }
                }
            }).catch(err => {
                console.log(err || "网络错误，请检查网络连接")
            })
        },
        // 获取期数信息
        async getNumber(cateNum) {
            let areaCodeList = []
            if (this.siteCode === 'gss') {
                areaCodeList = this.aeraValueList
            } else {
                areaCodeList = [this.areaValue]
            }
            let infoYear = cateNum === 'second' ? this.yearFValue : this.yearValue
            let data = {
                areaCodeList,
                siteId: this.siteId,
                materialParam: this.materialParam,
                infoYear,
            }
            await this.$axios.post("/new/search/infoNumList", data).then(res => {
                if (res.data.success && res.data.obj) {
                    if (cateNum !== "second") {
                        this.numberList = res.data.obj
                        this.numberValue = res.data.obj[this.numberList.length - 1]
                    }
                    if (this.siteCode === 'gss' && cateNum !== 'first') {
                        this.numberFList = res.data.obj
                        this.numberFValue = res.data.obj[this.numberFList.length - 1]
                    }
                }
            }).catch(err => {
                console.log(err || "网络错误，请检查网络连接")
            })
        },
        // 获取 信息价说明查询
        async getInfo() {
            let areaCodeList = []
            if (this.siteCode === 'gss') {
                areaCodeList = this.aeraValueList
            } else {
                areaCodeList = [this.areaValue]
            }
            let data = {
                areaCodeList,
                siteId: this.siteId,
                materialParam: this.materialParam,
                startInfoYear: this.yearValue,
                endInfoYear: this.yearFValue,
                startInfoNum: this.numberValue,
                endInfoNum: this.numberFValue,
                categoryId: this.treeId,
            }
            await this.$axios.post("/new/search/noticeList", data).then(res => {
                if (res.data.success && res.data.obj) {
                    this.detailInfo = res.data.obj
                    if (this.detailInfo.length > 0) {
                        this.defaultActiveKeyCity = this.detailInfo[0].areaName
                        this.detailDataList = this.detailInfo[0].noticeInfoDTOList
                        this.defaultActiveKeyData = this.detailDataList[0].noticeName
                        this.detailContain = this.detailDataList[0].noticeDetail
                        this.previousError = this.detailDataList[0].previousError
                    }
                }
            }).catch(err => {
                console.log(err || "网络错误，请检查网络连接")
            })
        },
        //  获取表格数据
        async getTableData() {
            this.loading = true
            await this.$axios.post("/new/search/infoPriceList", this.page).then(res => {
                if (res.data.success && res.data.obj) {
                    let arr = res.data.obj.infoPriceDTOList
                    this.tableData = arr
                    this.page.total = res.data.obj.total
                    this.initSearchIdList = res.data.obj.searchIdList ? res.data.obj.searchIdList : []
                    // 父级 iframe标签
                    var iframe = window.parent.document.getElementById('menuFrame');
                    if (iframe) {
                        this.$nextTick(() => {
                            var height = this.$refs.toInSearchBody.offsetHeight
                            iframe.height = height + 20
                        })
                    }
                }
                this.loading = false
            }).catch(err => {
                this.loading = false
                console.log(err || "网络错误，请检查网络连接")
            })
        },
        // 查询表格数据
        async searchTableData() {
            this.page.pageNum = 1;
            this.page.total = 0;
            this.page.pageSize = 10;
            let areaCodeList = []
            if (this.siteCode === 'gss') {
                areaCodeList = this.aeraValueList
            } else {
                areaCodeList = [this.areaValue]
            }
            this.seachForm = {
                areaCodeList,
                aeraValueListTotal: this.aeraValueListTotal,
                siteId: this.siteId,
                startInfoYear: this.yearValue,
                endInfoYear: this.yearFValue,
                startInfoNum: this.numberValue,
                endInfoNum: this.numberFValue,
                materialParam: this.materialParam,
                categoryId: this.treeId,
                searchId: this.initSearchIdList[0],
                searchIdList: this.initSearchIdList,
            }
            Object.assign(this.page, this.seachForm)
            await this.getTableData()
        },
        // 通性的材料分类
        async getMaterial() {
            let params = {
                searchId: this.initSearchIdList[0],
                siteId: this.siteId,
            }
            this.spinning = true
            this.gData = []
            await this.$axios.get("/old/search/ajax/infoCategoryTreeList", {params}).then(res => {
                if (res.data) {
                    let arr = res.data
                    let treeDataChild = setTreeData(arr)
                    this.gData = [
                        {id: '', name: '所有', children: treeDataChild}
                    ]
                }
                this.spinning = false
            }).catch(err => {
                this.spinning = false
                console.log(err || "网络错误，请检查网络连接")
            })
        },
        // 通性的材料分类
        async getGSMaterial() {
            let data = {
                searchIdList: this.initSearchIdList,
                siteId: this.siteId,
            }
            this.spinning = true
            this.gData = []
            await this.$axios.post("/old/gs/search/ajax/infoCategoryTreeList", data).then(res => {
                if (res.data) {
                    let arr = res.data
                    let treeDataChild = setTreeData(arr)
                    this.gData = [
                        {id: '', name: '所有', children: treeDataChild}
                    ]
                }
                this.spinning = false
            }).catch(err => {
                this.spinning = false
                console.log(err || "网络错误，请检查网络连接")
            })
        },
        // 表格分页
        onShowSizeChange(current, size) {
            this.page.pageNum = current
            this.page.pageSize = size
            this.getTableData()
        },
        // 通性 城市 tags 点击
        async tagclick(item, index) {
            this.activeIndex = index
            if (this.areaValue != item.areaCode) {
                this.areaValue = item.areaCode
                this.sectionExplains = ""
                await this.getYears()
                await this.getNumber()
                this.treeId = ''
                await this.searchTableData()
                await this.getInfo()
                // 材料分类
                this.getMaterial()
            }
        },
        // 年 变化
        async yearChange(val) {
            if (val === 'SC') {
                await this.getNumber('second')
            } else {
                await this.getNumber('first')
            }
            if (this.siteCode !== 'gss') {
                this.treeId = ''
                await this.searchTableData()
                await this.getInfo()
                this.getMaterial()
            }
        },
        // 通性 第一个 期数 变化
        async numberChange() {
            this.treeId = ''
            await this.searchTableData()
            await this.getInfo()
            this.getMaterial()
        },
        /// 查询
        async searchTableFn() {
            this.treeId = ''
            await this.searchTableData()
            await this.getInfo()
            if (this.siteCode === 'gss') {
                this.getGSMaterial()
            } else {
                this.getMaterial()
            }
        },
        // 点击菜单树
        getTreeNode(valObj) {
            this.treeId = valObj.id
            this.sectionExplains = valObj.icon
            this.getInfo()
            this.searchTableData()
        },
        // 级联 地区
        async aeraChange(val) {
            this.aeraValueList = []
            if (val.length > 0) {
                val.forEach(item => {
                    let cityValue = item[item.length - 1]
                    this.aeraValueList.push(cityValue)
                })
            }
        },
        callbackCity(val) {
            if (val) {
                this.detailDataList = this.detailInfo.find(item => item.areaName === val).noticeInfoDTOList
                this.defaultActiveKeyData = this.detailDataList[0].noticeName
                this.detailContain = this.detailDataList[0].noticeDetail
                this.previousError = this.detailDataList[0].previousError
            }
        },
        callbackData(val) {
            if (val) {
                this.detailContain = this.detailDataList.find(item => item.noticeName === val).noticeDetail
                this.previousError = this.detailDataList.find(item => item.noticeName === val).previousError
            }
        },

        getBar(row) {
            let query = {
                id: row.id,
                siteId: this.siteId,
            }
            if (this.siteCode === 'gss') {
                query.areaCode = JSON.stringify(this.page.aeraValueListTotal)
            } else {
                query.areaCode = this.areaValue
            }
            let routeUrl = this.$router.resolve({
                path: "/" + this.siteCode + "/toInfoSearch/barchart",
                query,
            })
            window.open(routeUrl.href, "_blank")
        },
        getLine(row) {
            let areaCode = this.page.areaCodeList
            let paramsList = {
                yearValue: this.yearValue,
                yearEndValue: this.yearFValue,
                numberValue: this.numberValue,
                numberEndValue: this.numberFValue,
                materialParam: this.materialParam,
            }
            if (this.siteCode !== 'gss') {
                paramsList.yearEndValue = this.yearValue,
                    paramsList.numberEndValue = this.numberValue
            }
            paramsList = JSON.stringify(paramsList)
            let routeUrl = this.$router.resolve({
                path: "/" + this.siteCode + "/toInfoSearch/linechart",
                query: {id: row.id, siteId: this.siteId, areaCode: JSON.stringify(areaCode), paramsList}
            });
            window.open(routeUrl.href, '_blank');
            // this.$router.push({path:"/"+this.siteCode+"/toInfoSearch/linechart",query:{id:row.id,siteId:this.siteId,areaCode,paramsList},})
        },
    },
};